import React from 'react';
import AppConfig from '@config';
import * as assets from '@assets';
import CapaHelperImg from '../assets/CapaHelperImg.png';
import {
  CapaQuotationChatMessage,
  CapaQuotationChatMessageType
} from '@generated/graphql';
import { CommonMessageType } from '../types';
import { Avatar, makeStyles } from '@material-ui/core';
import { useSelector } from '@store';

const useStyles = makeStyles(() => {
  return {
    avatar: {
      width: 32,
      height: 32,
      borderRadius: '50%',
      marginRight: 12,
      cursor: 'pointer'
    }
  };
});

interface Props {
  isOwner: boolean;
  message?: CapaQuotationChatMessage;
}

const ChatMessageProfileImgPresenter: React.FC<Props> = ({
  isOwner,
  message
}) => {
  const classes = useStyles();
  const messageType = message?.message?.messageType ?? undefined;
  const partnerId = useSelector((state) => state.chat.quotationPartnerId);

  const isChatStart = messageType === CapaQuotationChatMessageType.ChatStart;
  const isNoneProfileImg =
    messageType && CommonMessageType.includes(messageType);
  const profileId = message?.profileId ?? undefined;
  let profileImg = profileId
    ? `${AppConfig.fileApiUrl}/file/${profileId}`
    : assets.DefaultCompanyThumbnail;
  profileImg = isChatStart ? CapaHelperImg : profileImg;
  if (isOwner || isNoneProfileImg) {
    return null;
  }

  const handleMoveProfilPage = () => {
    window.open(`${AppConfig.baseUrl}/companyInfo?partnerId=${partnerId}`);
  };

  return (
    <Avatar
      src={profileImg}
      className={classes.avatar}
      onClick={handleMoveProfilPage}
    >
      <img src={profileImg} alt="profile" />
    </Avatar>
  );
};

export default ChatMessageProfileImgPresenter;
